// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NotFoundPage_notFoundPage__iaIMR","notFound":"NotFoundPage_notFound__Ek1mo","notFoundContent":"NotFoundPage_notFoundContent__ijRmM"};